export default __webpack_public_path__ + "static/network-ef47cd638e56676670523fb8a77b721c.png";